import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Typography } from '@material-ui/core'
import Button from 'components/Button/Button'
import { useStyles } from '../IntegrationIndexPage_style'

const CTANewIntegration = ({ onContactClick }) => {
    const classes = useStyles()

    return (
        <Box className={classes.cardWrapper}>
            <Box className={`${classes.card} ${classes.cardCta}`}>
                <Box className={`${classes.cardContent} ${classes.cardCtaContent}`}>
                    <Typography variant='h3' className={classes.ctaTitle}>
                        <FormattedMessage id='integrations_catalogue.want_to_integrate.title' />
                    </Typography>
                    <Typography variant='body1' className={classes.ctaSubtitle}>
                        <FormattedMessage id='integrations_catalogue.want_to_integrate.subtitle' />
                    </Typography>
                    <Box className={classes.ctaButtonBox}>
                        <Button
                            variant='primary'
                            size='medium'
                            onClick={onContactClick}
                            className={classes.ctaButton}
                        >
                            <FormattedMessage id='integrations_catalogue.want_to_integrate.button' />
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default CTANewIntegration
